<template>
  <modal :show="show" @change="$emit('change', $event)" width="550">
    <template v-slot:header>
      <span>{{header}}</span>
    </template>
    <template v-slot:main>
      <div class="modal-content">
        <div class="tes-text modal-content-text" v-html="message">
        </div>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from "../common/Modal";
import { mapGetters } from "vuex";

export default {
  name: "ModalReadingsInfo",
  components: { Modal },
  model: {
    prop: "show",
    event: "change",
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: ""
    },
    header:{
      type: String,
      default: ""
    },
  },
  computed: {
    ...mapGetters("locale",["currentLocale"]),
  },
  methods: {},
  created() {},
  watch: {},
};
</script>

<style lang="scss">
.modal-content-text {
  text-align: center;
}
</style>